import React from "react";

import { Skeleton } from "../../../../../components/Skeleton";
import { Cell, CellLabel, CellValue, StatusDot } from "../../styles";
import { HealthCellProps, HealthSummary } from "./types";

const UNAVAILABLE: HealthSummary = { tone: "unknown", label: "Unavailable" };

export const HealthCell = <T,>({
  label,
  section,
  summarise,
}: HealthCellProps<T>) => {
  const summary =
    section.state === "available" ? summarise(section.data) : UNAVAILABLE;

  return (
    <Cell>
      <CellLabel>{label}</CellLabel>
      {section.state === "loading" ? (
        <Skeleton variant="text" width="60%" height="1.5rem" />
      ) : (
        <CellValue>
          <StatusDot $tone={summary.tone} aria-hidden="true" />
          {summary.label}
        </CellValue>
      )}
    </Cell>
  );
};
